export default __webpack_public_path__ + "static/media/b-account-a.5e851089.svg";